import * as React from 'react';

import EnterprisePageHeader from 'bundles/composable-page-header-enterprise/header-renderers/EnterprisePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/org-scoped/ThirdPartyOrganizationContext';
import EnterpriseOrgScopedModalManager from 'bundles/unified-home-common/components/enterprise/modals/EnterpriseOrgScopedModalManager';
import OrgScopedAdminImpersonationBannerRenderer from 'bundles/unified-home-common/components/org-scoped/OrgScopedAdminImpersonationBannerRenderer';

import 'css!bundles/unified-home-common/__styles__/index';

type Props = {
  children: React.ReactNode;
  hideAdminImpersonationBanner?: boolean;
};

/*
Use this to add the header/footer to a page in the enterprise context.

Ensure this is nested beneath bundles/unified-common/providers/org-scoped/data/EnterpriseOrgScopedPageDataProvider
and bundles/unified-common/providers/org-scoped/modals/EnterpriseOrgScopedModalManagerProvider
*/
const EnterpriseOrgScopedHeaderFooterWrapper = ({ children, hideAdminImpersonationBanner }: Props) => {
  const thirdPartyOrg = useThirdPartyOrganization();

  return (
    <React.Fragment>
      <EnterprisePageHeader backupThirdPartyOrg={thirdPartyOrg} />
      <UniversalPageFeatures authModalOptions={{ isEnterprise: true }} />
      {!hideAdminImpersonationBanner && <OrgScopedAdminImpersonationBannerRenderer />}
      <main>{children}</main>
      <PageFooter hideTopBorder />
      <EnterpriseOrgScopedModalManager />
    </React.Fragment>
  );
};

export default EnterpriseOrgScopedHeaderFooterWrapper;
